import * as React from "react"

const Close = (props) => (
  <svg
    width={52}
    height={52}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="m18.534 35.333-1.867-1.866L24.134 26l-7.467-7.467 1.867-1.866L26 24.133l7.467-7.466 1.867 1.866L27.867 26l7.467 7.467-1.867 1.866L26 27.867l-7.466 7.466Z"
      fill="#E24E06"
    />
    <rect
      x={1}
      y={1}
      width={50}
      height={50}
      rx={25}
      stroke="#E24E06"
      strokeWidth={2}
    />
  </svg>
)

export default Close
